/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action, computed } from '@ember/object';
import Component from '@glimmer/component';
import { FlyKeyboardEvent } from '@customerio/fly-components/types/fly-components/events';
import { tracked } from '@glimmer/tracking';
import { isEmpty } from '@ember/utils';

interface DomainDnsArgs {
  type: string;
  domain: string;
  parentDomain: string;
  value: string;
  domainIsEditable: boolean;
}

export default class DomainDns extends Component<DomainDnsArgs> {
  @tracked domain = '';

  @computed('args.{type,parentDomain,domain}')
  get recordHostName() {
    if (isEmpty(this.args.domain)) {
      return null;
    }
    return !this.args.parentDomain ? this.args.domain : this.args.domain.replace(`.${this.args.parentDomain}`, '');
  }

  get type() {
    return this.args.type ?? null;
  }

  @action
  setDomain() {
    if (this.args.domain) {
      this.domain = this.args.domain;
    }
  }

  get parentDomain() {
    return this.args.parentDomain ?? null;
  }

  get value() {
    return this.args.value ?? null;
  }

  get domainIsEditable() {
    return this.args.domainIsEditable ?? false;
  }

  @computed('args.value')
  get rows() {
    return this.args.value.length > 80 ? 6 : 1;
  }

  @computed('args.value')
  get mxPriority() {
    if (this.type !== 'MX') {
      return null;
    }
    if (this._mxValueMatches) {
      let [, priority] = this._mxValueMatches;
      return priority;
    }
    return null;
  }

  @computed('args.{value,type}')
  get formattedValue() {
    if (this.type !== 'MX') {
      return this.value;
    }
    if (this._mxValueMatches) {
      let [, , domain] = this._mxValueMatches;
      return domain;
    }
    return this.value;
  }

  @action
  select({ target }: FlyKeyboardEvent<HTMLElement>) {
    target.focus();
    //@ts-ignore
    target.select();
  }

  @computed('args.value')
  get _mxValueMatches() {
    // From a value of: "10 mx.dns.com", we want to extract the number 10 and
    // the part after the number 10.
    let pattern = /(\d{2,3})\s(.+)/;
    return this.args.value.match(pattern);
  }

  @computed('args.type')
  get dnsTextareaContainerWidthClass() {
    if (this.args.type === 'CNAME') {
      return 'w-5/12';
    }

    if (this.args.type === 'MX') {
      return 'w-4/12';
    }

    return 'w-6/12';
  }
}
